module.exports = __webpack_public_path__ + "img/rynenation-logo-light-large.db1cd667.png";